import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/* Настройки рабочего пространства с сервера (/api/settings) — одни на «Общие сведения», «Основные настройки»
   и «Общую информацию». После сохранения в одном окне остальные обновляются событием. Менять может владелец и администратор. */

export type Recipient = { id: string; name: string; email: string };

export type WorkspaceSettings = {
  name: string;
  slug: string;
  language: string;
  timezone: string;
  inactivityMinutes: number;
  digestEnabled: boolean;
  digestRecipients: Recipient[];
  description: string;
  website: string;
  industry: string;
  companySize: string;
  notifyEmail: string;
  canEdit: boolean;
};

export type SettingsPatch = Partial<Omit<WorkspaceSettings, "digestRecipients" | "canEdit">> & { digestRecipients?: string[] };

const EVENT = "hub:workspace-settings";

export function useWorkspaceSettings() {
  const [data, setData] = useState<WorkspaceSettings | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    api<WorkspaceSettings>("/settings").then(setData, setError);
    const on = (e: Event) => setData((e as CustomEvent<WorkspaceSettings>).detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);

  const save = useCallback(async (patch: SettingsPatch) => {
    const next = await api<WorkspaceSettings>("/settings", { method: "PATCH", json: patch });
    window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
    return next;
  }, []);

  return { data, error, save };
}
